import { FaShare } from "react-icons/fa";
import { useParams } from "react-router-dom";
import "./styles.css";

const Clickable = () => {
  const { mode } = useParams();
  return mode === "view" ? (
    <div id="clickable" className="clickable">
      <FaShare />
      <div className="clickable-hover">
        Este conteúdo pode ser clicado e redirecionado para o painel Comprovei
      </div>
    </div>
  ) : (
    <div />
  );
};

export default Clickable;
